// extracted by mini-css-extract-plugin
module.exports = {"companyDetails":"CompanyDetails_companyDetails__3Blw2"};